/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'organization-file-category-new': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M13.125 6.25h-2.5v-2.5h-1.25v2.5h-2.5V7.5h2.5V10h1.25V7.5h2.5V6.25zM17.5 15h-6.875v-2.5h3.75a1.252 1.252 0 001.25-1.25V2.5c0-.69-.56-1.25-1.25-1.25h-8.75c-.69 0-1.25.56-1.25 1.25v8.75c0 .69.56 1.25 1.25 1.25h3.75V15H2.5c-.69 0-1.25.56-1.25 1.25v2.5H2.5v-2.5h6.875v2.5h1.25v-2.5H17.5v2.5h1.25v-2.5c0-.69-.56-1.25-1.25-1.25zM5.625 2.5h8.75l.001 8.75H5.625V2.5z"/>'
  }
})
